import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const animatedHeaders = () => {
  const selectors = [];

  if (!Array.isArray(selectors) || !selectors.length) return;

  const elements = document.querySelectorAll(selectors.join(", "));
  if (!elements.length) return;

  elements.forEach((el) => {
    const parent = el.parentElement;

    ScrollTrigger.create({
      trigger: el,
      start: "top 70%",
      end: "bottom top",
      onEnter: () => {
        el.classList.add("in-view");
        if (parent) parent.classList.add("rotate-in");
      },
      onLeave: () => {
        el.classList.remove("in-view");
        if (parent) parent.classList.remove("rotate-in");
      },
      onEnterBack: () => {
        el.classList.add("in-view");
        if (parent) parent.classList.add("rotate-in");
      },
      onLeaveBack: () => {
        el.classList.remove("in-view");
        if (parent) parent.classList.remove("rotate-in");
      },
    });
  });
};

export { animatedHeaders };
